/* ------------------------------------------------------------------
   صفحهٔ آغاز — همان نشانِ index.html، در React
   ------------------------------------------------------------------
   🔴 ۱۴۰۵/۰۸/۱۳: تا رسیدنِ پوستهٔ پنل (یا صفحهٔ ورود) همین یکی دیده
   می‌شود — به‌جای «در حال آماده‌سازی» و «در حال بررسی وضعیت ورود» که هر
   کدام چرخندهٔ خودشان را جای دیگری از صفحه نشان می‌دادند.

   ⚠️ کلاس‌ها و ظاهر در `<style>` ِ index.html‌اند، نه tokens.css: نسخهٔ
   HTML پیش از هر CSSی کشیده می‌شود و این دو باید مو به مو یکی باشند —
   React که جای آن را می‌گیرد، کاربر نباید چیزی ببیند.
   · نشان: اگر در نسخهٔ HTML رسیده بود (از کش)، همان لحظه دیده می‌شود، نه
     پس از رویدادِ load ِ عنصرِ تازه — وگرنه یک لحظه ناپدید می‌شد.
   · چرخنده: تأخیرِ ۶۰۰ میلی‌ثانیه از آغازِ صفحه حساب می‌شود، نه از ساختنِ
     این عنصر — وگرنه چرخنده‌ای که در HTML پیدا شده بود دوباره پنهان می‌شد.
   ------------------------------------------------------------------ */

const SPIN_DELAY_MS = 600

export function BootScreen() {
  const delay = Math.max(0, SPIN_DELAY_MS - Math.round(performance.now()))

  return (
    <div className="pf-boot" role="status" aria-label="در حال بارگذاری">
      <img
        className="pf-boot__mark"
        src="/brand/logo-full.png"
        alt=""
        width={56}
        height={62}
        ref={(el) => {
          if (el?.complete && el.naturalWidth > 0) el.dataset.loaded = ''
        }}
        onLoad={(event) => {
          event.currentTarget.dataset.loaded = ''
        }}
      />
      <span className="pf-boot__spin" aria-hidden="true" style={{ animationDelay: `0s, ${delay}ms` }} />
    </div>
  )
}
